import React, { FunctionComponent } from "react";
import { Button } from "@cmsgov/ds-medicare-gov";
import { useTranslate } from "../helpers";

interface FootnoteMarkerProps {
  id: string;
  marker: string;
}

const FootnoteMarker: FunctionComponent<FootnoteMarkerProps> = ({
  id,
  marker,
}) => {
  const t = useTranslate();
  const footnoteId = `${id}-footnote`;
  const markerId = `${id}-marker`;

  return (
    <Button
      size="small"
      className="Footnote__marker"
      id={markerId}
      aria-label={t("footnote_marker.go_to_content")}
      onClick={(): void => {
        const footnote: HTMLDivElement | null = document.querySelector(
          `#${footnoteId}`
        );
        footnote && footnote.scrollIntoView(false); // scroll bottom to bottom of viewport
        footnote?.focus();
      }}
    >
      <sup>{marker}</sup>
    </Button>
  );
};

export default FootnoteMarker;
